module.exports = __webpack_public_path__ + "static/media/filter-back-button.65f475e2.svg";